RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const config = [
        {
            name: 'top',
            sizes: {
                md: 12
            },
            page: 0
        },
        {
            name: 'stories',
            sizes: {
                md: 12
            },
            page: 1
        },
        [
            {
                name: 'reach-impressions',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 2
            },
            {
                name: 'retention-rate',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 2
            }
        ],
        {
            name: 'by-type',
            sizes: {
                md: 12
            },
            page: 3
        }
    ];

    const ExportLayout = RivalIQ.apps.Dashboard.views.ExportWidgets.extend({
        childView: RivalIQ.apps.Dashboard.views.ExportLayout.extend({
            config: config
        })
    });

    curations.InstagramInsightsStoryDayCuration = curations._BaseInstagramInsightsCuration.extend({

        widgetsView: App.views.InstagramInsightsLayout.extend({
            config: config,

            showLeftToolbarActions: function () {
                const me = this;

                const props = _.extend({
                    companyId: me.getProp('companyId'),
                    searchTerm: me.getProp('searchTerm')
                }, me.getProp('fromProps'));

                const backPath = me.dashboardModel.router.resolveCurationRoute(RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_STORIES, props);

                me.leftActions.show(new RivalIQ.views.Link({
                    className: 'btn btn-default btn-back-link discovery-back-btn',
                    linkName: '<span class="fa fa-chevron-left"></span>',
                    attributes: _.constant({
                        href: backPath
                    })
                }), {
                    preventDestroy: true
                });

                me.leftActions.show(new App.views.SearchBar({
                    dashboardModel: me.dashboardModel,
                    omitResultsSummary: true
                }), {
                    preventDestroy: true
                });
            }
        }),
        widgetView: App.views.InsightsDetailsLayout,
        exportWidgetsView: ExportLayout,

        exportTitle: 'Instagram Insights Story',

        loadConfiguration: function () {
            const me = this;
            return RivalIQ.data.configuration.fetch(me, me.getProps());
        },

        getBackPath: function (widgetProps) {
            const me = this;

            const props = _.extend(me.getProps(), widgetProps);
            const backPathProps = _.pick(props, ['storyDay', 'companyId', 'fromProps']);

            return me.router.resolveCurationRoute(RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_STORY_DAY, backPathProps);
        },

        processProps: function (props) {
            const me = this;

            // We don't allow filtering by type unless you're in the details view of the table looking
            // at stories.
            if (me.isFocus() || props.objectType !== 'story') {
                props.mediaTypeFilter = undefined;
            }

            return props;
        }
    });
});
